import { PostViewInDto, RegisterViewOutDto } from "../../../types/post-views.dto";

export const REGISTER_VIEW = "REGISTER_VIEW";
export const REGISTER_VIEW_SUCCESS = "REGISTER_VIEW_SUCCESS";
export const REGISTER_VIEW_ERROR = "REGISTER_VIEW_ERROR";
export const RESET_REGISTER_VIEW = "RESET_REGISTER_VIEW";

export interface RegisterView {
  type: typeof REGISTER_VIEW;
  payload: RegisterViewOutDto;
}

export interface RegisterViewSuccess {
  type: typeof REGISTER_VIEW_SUCCESS;
  payload: PostViewInDto;
}

export interface RegisterViewError {
  type: typeof REGISTER_VIEW_ERROR;
  payload: string | boolean;
}

export interface ResetRegisterView {
  type: typeof RESET_REGISTER_VIEW;
  payload: null;
}

export interface State {
  data: PostViewInDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = RegisterView | RegisterViewSuccess | RegisterViewError | ResetRegisterView;

